import React, { useState, useEffect, useRef } from "react";
import { compose } from "recompose";
import withTranslator from "../Translator/withTranslation";
import styled from "@emotion/styled";

const Badge = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    @media (max-width: 1023px) {
        position: absolute;
        z-index: 2;
        background: rgba(255,255,255,0.9);
        width: 100%;
        height: 35px;
        transition-duration: 500ms;
        animation-name: fadein;
        opacity:0;
        padding:4px;
    }
`;
const BadgeContainer = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    margin-left:10px;
    @media (max-width: 1023px) {
        flex-direction:row;
        margin-left:0px;
    }
`;
const BadgeImage = styled.img`
    width: 50px;
    height: 50px;
    padding: 5px;
    @media (max-width: 1023px) {
        width: 25px;
        height: 25px;
    }
`;
const BadgeLabel = styled.div`
    font-size: 16px;
    @media (max-width: 1023px) {
        font-size: 12px;
    }
`;

const StarRating = styled.div`
  position: relative;
  display: inline-block;
  font-size: 15px;
  color: #ccc; /* Background star color */
`;
const StarRatingValue = styled.div`
    margin-right:10px;
    font-size: 16px;
    font-weight: 600;
    @media (max-width: 1023px) {
        margin-right: 5px;
    }
`;

const Stars = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  overflow: hidden;
  color: gold; /* Filled star color */
  white-space: nowrap;
`;

const StarsBackground = styled.div`
  content: "★★★★★";
  display: block;
`;

const StarsForeground = styled(StarsBackground)`
  position: absolute;
  top: 0;
  left: 0;
  color: gold;
`;

const StarRatingContainer = styled.div`
    display:flex;
    margin-top:5px;
    @media (max-width: 1023px) {
        flex-direction:row;
        margin-top:0px;
        margin-left:5px;
    }
`;

const GoogleReviewsBadgeComponent = ( props ) => {
    const rating = props.rating ? props.rating : 0;
    const ratingMax = props.ratingMax ? props.ratingMax : 5
    const scale = 0.95;
    const percentage = (rating / ratingMax * 100 * scale).toFixed(2);
    const badgeRef = useRef();

     
    useEffect(() => {
        badgeRef.current.style.opacity = 1;    
    },[]);

    return (
        <Badge ref={badgeRef} className="flex items-center">
            <BadgeImage  alt="Google Reviews" src="/assets/img/front/google-review-badge-logo.png" />
            <BadgeContainer>
                <BadgeLabel>{props.t('google_rating')}</BadgeLabel>
                <StarRatingContainer>
                    <StarRatingValue>{rating}</StarRatingValue>
                    <StarRating>
                        <StarsBackground>★★★★★</StarsBackground>
                        <Stars style={{ width: `${percentage}%` }}>
                            <StarsForeground>★★★★★</StarsForeground>
                        </Stars>
                    </StarRating>
                </StarRatingContainer>
            </BadgeContainer>
        </Badge>
    );
}

export const GoogleReviewsBadge = compose(
    withTranslator
)(GoogleReviewsBadgeComponent);